import type { ServiceCode } from '../../common/enums/ServiceCode';
import type { IRequest } from '../../common/interfaces/IRequest';
import { CustomControlStatus } from '../../common/enums/CustomControlStatus';
import { ProcedureStatus } from '../../common/enums/ProcedureStatus';
import { RequestStatus } from '../../common/enums/RequestStatus';

export function isPendingRequestForService(request: IRequest, serviceCode: ServiceCode) {
    return (
        request.service.code === serviceCode &&
        request.status === RequestStatus.active &&
        request.procedure &&
        request.procedure.status === ProcedureStatus.active &&
        request.procedure.customControlStatus === CustomControlStatus.withPatient
    );
}
